module.exports = __webpack_public_path__ + "roboto-mono-latin-ext-400-normal.woff";